import { render } from "./QuestionView.vue?vue&type=template&id=1b9ede24&scoped=true"
import script from "./QuestionView.vue?vue&type=script&lang=js"
export * from "./QuestionView.vue?vue&type=script&lang=js"

import "./QuestionView.vue?vue&type=style&index=0&id=1b9ede24&scoped=true&lang=scss"

import exportComponent from "/builds/Partout/motus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9ede24"]])

export default __exports__